import { EventType } from '@/analytics/types';

import { NewYearHeroBackground } from './common/NewYearHeroBackground';
import HolidayHeroTemplate25 from './HolidayHeroTemplate25';

const ValentinesDayHero = () => {
  return (
    <HolidayHeroTemplate25
      Background={NewYearHeroBackground}
      titleMsgKey="valentines_day_2026_headline"
      subcopyMsgKey="valentines_day_2026_copy"
      buttonProps={{
        href: '/store',
        ctaLabel: 'call_to_action_button_text',
        onClick: () => {
          void window.ouraAnalytics.track(EventType.CTAClicked, {
            cta: 'shop now',
            action: 'go to store',
            location: 'home hero',
            path: '/store',
          });
        },
      }}
      dataCy="valentines-day-hero"
    />
  );
};

export default ValentinesDayHero;
